module.exports = __webpack_public_path__ + "7b35fa3ab6007201cdd53d9a4ca4cae9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/detsky-tabor-1-1.jpg
// module id = 1211
// module chunks = 0